<template>
    <div>
        <b-form-group class="title_div p-3 mb-2 bkbor">
            <b-row>
                <b-col>
                    <label>使用者帳號</label>：
                    <label>{{ DetailData.userAccount }}</label>
                </b-col>
                <b-col>
                    <label>使用者姓名</label>：
                    <label>{{ DetailData.userName }}</label>
                </b-col>
                <b-col>
                    <label>所屬群組</label>：
                    <label>{{ DetailData.AG_Name }}</label>
                </b-col>
            </b-row>
            <b-row>
                <b-col >
                    <label>電子郵件</label>：
                    <label>{{DetailData.email}}</label>
                </b-col>
            </b-row>
        </b-form-group>
        <div class="ustify-content-md-center">
            <b-card
            header-class="h7"
            no-body>
                <template #header>
                    請定期變更密碼，每6個月必須變更1次，且新密碼不得與舊密碼相同。<br />
                    以下欄位均為必填欄位，密碼長度6個字元~12個字，以英文大小寫、數字等限定，需至少一位大寫、一位小寫、一位數字、一位特殊字元(如：!@#$%^&*)。
                </template>
                <b-table-simple hover small caption-top>
                    <b-tr>
                        <b-td class="p-2 border-0">
                            <label>使用者密碼*</label>
                            <b-form-input
                                :type="passSetting.type"
                                placeholder="請輸入使用者密碼"
                                maxlength="12"
                                v-model="DetailData.pass">
                            </b-form-input>
                            <a href="javascript:void(0)" @click="showPwdEye(passSetting)">
                                <img class="showeye" v-bind:src="'/images/backend/'+passSetting.image" alt="顯示或隱藏明碼"/>
                            </a>
                        </b-td>
                        <b-td class="p-2 border-0">
                            <label>確認密碼*</label>
                            <b-form-input
                                :type="confpassSetting.type"
                                placeholder="請輸入使用者密碼"
                                maxlength="12"
                                v-model="DetailData.chkpass">
                            </b-form-input>
                            <a href="javascript:void(0)" @click="showPwdEye(confpassSetting)">
                                <img class="showeye" v-bind:src="'/images/backend/'+confpassSetting.image" alt="顯示或隱藏明碼"/>
                            </a>
                        </b-td>
                    </b-tr>
                    <b-tr>
                        <b-td class="col-xs-1 p-2 border-0">
                            <label>驗證碼*</label>
                            <input type="tel" maxlength="6" class="passcode p-2" v-model="code" placeholder="請輸入驗證碼" ></input>
                        </b-td>
                        <b-td class="captchacode p-2 border-0 align-content-end">
                            <img
                                :src="imageCode"
                                alt="captchaImage"
                                class="captcha"
                                style="height: 55px !important;" />
                            <a
                                href="javascript:void(0)"
                                class="reload"
                                title="點我可重新產生驗證碼"
                                @click="getImageCode">

                                <img src="/images/backend/icon-restart.png" alt="點我可重新產生驗證碼"/>
                            </a>
                        </b-td>
                    </b-tr>
                    <!--功能操作區-->
                    <b-tr>
                        <b-td>
                            <b-button @click="save">
                                變更密碼
                            </b-button>
                        </b-td>
                    </b-tr>
                </b-table-simple> 
            </b-card>
        </div>
    </div>
</template>
<script>
export default{
    components:{
    },
    data(){
        return{
            //群組選項
            groupOptions:[],
          
            //密碼顯示設定
            passSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //確認密碼顯示設定
            confpassSetting:{
                show: false,
                type: "password",
                image: "eye.png",
            },
            //詳細資料
            DetailData:{AG_ID:null,status:null},

            //帳號編號
            id:0,
            //是否更新
            isUpdate:false,

            //圖形驗證碼變數
            code:"",
            imageCode:"",
            imageCodeArr:"",

            //API設定區
            apiGetImageCode:(data)=> this.userRequest.post("bicd/GetImageCode",data),
            apiUserInfo:(data) => this.userRequest.post("bicd/UserInfo",data),
        };
    },
    props:["value"],
    computed:{
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        groupOptions(){
            this.DetailData.AG_Name = this.groupOptions.filter(x=> x.value == this.DetailData.AG_ID)[0].text;
        }
    },
    methods:{
        //初始化
        init(){
            this.showPwdEye(this.passSetting,'init');
            this.showPwdEye(this.confpassSetting,'init');
            
            this.getImageCode();
            //取得所有群組項目
            this.getGroup();
            //取得帳號詳細資訊
            this.getAccount();
        },
       //取得所有群組項目
        async getGroup(){
            try{
                //初始預設
                this.groupOptions.push({value:null, text:"請選擇所屬群組"});
                //POST 參數
                let jsonReq={
                    TYPE:"GROUP_OPTION",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq); 
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData.length >0){
                        jsonData.forEach((item)=>{
                            this.groupOptions.push({value:item.key,text:item.value});
                        });
                    }
                }
            }catch(err){
                console.log("ErrFunction: getGroup/n "+err);
            }
        },
        //取得帳號詳細資訊
        async getAccount(){
            try{
                //POST 參數
                let jsonReq = {
                    TYPE: "MyPage",
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token"); 
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/UserInfo",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status) {
                    if(json.Data != null){
                        let jsonData = JSON.parse(json.Data);
                        this.DetailData = jsonData;
                        this.DetailData.status = Number(this.DetailData.status);
                        this.DetailData.AG_Name = this.groupOptions.filter(x=> x.value == this.DetailData.AG_ID)[0].text;
                    }else{
                        //預設空值
                        this.DetailData ={
                            id:0,
                            AG_ID:null,
                            status:null
                        }
                    }
                }
            }catch(err){
                console.log("ErrFunction: getAccount/n "+err);
            }
        },
        //儲存
        save() {
            try{
                var imageCode = "";
                this.imageCodeArr.forEach( x => {
                    imageCode += x;
                })
                if(imageCode != this.code){
                    this.code = "";
                    this.getImageCode();
                    alert("驗證碼輸入錯誤");
                }

                //更新修改功能
                let json = {
                    TYPE:"UPDATE_MyPage",
                    User_Info_UPDATE:{
                        userId:this.id,
                        userName: this.DetailData.userName,
                        userAccount: this.DetailData.userAccount,
                        password: this.DetailData.pass,
                        checkPassword: this.DetailData.chkpass,
                        email: this.DetailData.email,
                        status: this.DetailData.status,
                        AG_ID: this.DetailData.AG_ID,
                    },
                };
                this.FunctionToken(this.functionUpdate,json);
            }catch(err){
                console.log("ErrFunction: save/n "+err);
            }
        },
        //更新功能
        functionUpdate(data){
            this.apiUserInfo(data)
                .then((res) => {
                    let json= JSON.parse(res.data);
                    if(json.Status){
                        this.$bvToast.toast("更新成功",{title:"提示",solid:true,});
                    }else{
                        //發生錯誤時，跳出提示
                        alert(this.Str_Replace(JSON.parse(json.Data),",","\r\n"));
                    }
                })
                .catch((err)=>{

                    console.log("ErrorFunction: functionInsert/n" ,err);
                });
        },
        //取得驗證圖
        getImageCode(){
            this.apiGetImageCode()
                .then((res) => {
                    const json = JSON.parse(res.data);
                    if (json.Status) {
                        let jsonImage = JSON.parse(json.Data);
                        this.imageCode = jsonImage.Image;
                        this.imageCodeArr = jsonImage.Code.split("");
                        
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
    },
}
</script>